var chunkToChildrenMap = {
	"8106": [
		2114,
		3613
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};